module.exports = __webpack_public_path__ + "assets/img/gift-7-97802b6f.png";